import React from 'react';
import classnames from 'classnames';
import { AvatarProps } from '../../types.d';

import styles from '../../Avatar.module.scss';

function EmployeeSurprise({
  size,
  className,
}: Pick<AvatarProps, 'size' | 'className'>): JSX.Element {
  return (
    <svg
      className={classnames(className, {
        [styles[size]]: size,
      })}
      x="0px"
      y="0px"
      viewBox="0 0 144 144"
      enableBackground="new 0 0 144 143.996"
      xmlSpace="preserve"
    >
      <g id="pistis">
        <g id="surprise_2_">
          <ellipse
            fill="#A6E3F9"
            cx="72"
            cy="71.993"
            rx="72"
            ry="71.998"
          />
          <g>
            <defs>
              <ellipse
                id="SVGID_13_"
                cx="72"
                cy="71.998"
                rx="72"
                ry="71.998"
              />
            </defs>
            <clipPath id="SVGID_2_">
              <use
                xlinkHref="#SVGID_13_"
                overflow="visible"
              />
            </clipPath>
            <g clipPath="url(#SVGID_2_)">
              <path
                fill="#00AFEC"
                d="M77.524,110.82c-6.343,4.166-8.107,12.686-3.941,19.029c0.334,0.508,0.705,0.975,1.091,1.424 l-0.011,0.008l37.834,43.968l15.907-12.005l-31.85-48.484C92.387,108.417,83.867,106.653,77.524,110.82z"
              />
              <circle
                fill="#00AFEC"
                cx="84.684"
                cy="122.459"
                r="14.136"
              />
              <path
                fill="#00AFEC"
                d="M98.744,123.113l-3.659,79.075H44.518l-20.896-83.042c-1.382-5.493,2.771-10.822,8.436-10.822h52.565 C92.686,108.324,99.117,115.058,98.744,123.113z"
              />
              <path
                fill="#00AFEC"
                d="M42.027,111.967c-5.795-5.231-14.734-4.775-19.966,1.02c-0.419,0.464-0.788,0.955-1.134,1.455 l-0.011-0.009l-33.941,49.079l16.082,12.715l39.991-44.296C48.279,126.137,47.822,117.198,42.027,111.967z"
              />
              <path
                fill="#283042"
                d="M101.061,58.586c-0.012,0.009-0.012,0.009-0.012,0.009"
              />
              <path
                fill="#0E0E11"
                d="M83.598,53.638l-3.862,0.525l-3.274-26.011l3.862-0.525c7.208-0.902,13.74,4.16,14.642,11.368l0,0 C95.868,46.204,90.806,52.736,83.598,53.638z"
              />
              <path
                fill="#0E0E11"
                d="M81.039,53.319l-10.546,1.384L66.3,21.274l9.506-1.194c6.265-0.825,12.012,3.668,12.837,9.932 l1.487,11.804C90.791,47.355,86.78,52.536,81.039,53.319z"
              />
              <path
                fill="#0E0E11"
                d="M55.106,82.23l-9.821,1.22c-5.225,0.635-10.065-3.087-10.7-8.312l-1.393-10.651l19.222-2.406 L55.106,82.23z"
              />
              <path
                fill="#FDC9A3"
                d="M53.694,110.225c1.065,6.52,7.213,10.941,13.733,9.876s10.942-7.213,9.877-13.733 c-1.065-6.52-7.213-10.941-13.733-9.876C57.051,97.557,52.629,103.706,53.694,110.225z"
              />
              <polygon
                fill="#FDC9A3"
                points="77.304,106.369 53.694,110.225 48.945,81.154 49.638,81.041 72.555,77.298"
              />
              <path
                fill="#FDC9A3"
                d="M63.969,28.384l-1.836,0.3C50.412,30.598,42.463,41.65,44.377,53.37l6.529,39.974l22.229-3.631 c11.163-1.823,18.735-12.351,16.911-23.514l-3.528-21.597C84.771,33.896,74.674,26.635,63.969,28.384z"
              />
              <path
                fill="#0E0E11"
                d="M77.352,55.205c-0.219,0-0.405-0.169-0.422-0.391c-0.017-0.233,0.157-0.437,0.39-0.455l5.737-0.436 c0.229-0.019,0.437,0.157,0.455,0.39c0.017,0.233-0.157,0.437-0.39,0.455l-5.737,0.436 C77.375,55.205,77.363,55.205,77.352,55.205z"
              />
              <path
                fill="#0E0E11"
                d="M62.525,55.841c-0.223,0-0.409-0.173-0.423-0.398c-0.014-0.233,0.164-0.434,0.397-0.448l6.227-0.378 c0.255-0.007,0.435,0.164,0.448,0.397c0.014,0.233-0.164,0.434-0.397,0.448L62.55,55.84 C62.541,55.841,62.533,55.841,62.525,55.841z"
              />
              <ellipse
                transform="matrix(0.9985 -0.0556 0.0556 0.9985 -3.3028 3.7598)"
                fill="#0E0E11"
                cx="65.872"
                cy="61.196"
                rx="1.621"
                ry="2.092"
              />
              <ellipse
                transform="matrix(0.9985 -0.0556 0.0556 0.9985 -3.2378 4.5359)"
                fill="#0E0E11"
                cx="79.844"
                cy="60.418"
                rx="1.621"
                ry="2.092"
              />
              <path
                fill="#0E0E11"
                d="M48.02,28.775l3.137-0.36l4.624,36.137l-22.14,2.854l-2.139-17.238 C30.117,39.621,37.57,30.045,48.02,28.775z"
              />
              <path
                fill="#FDC9A3"
                d="M45.051,69.449l4.88-0.793l-0.791-4.87c-0.437-2.689-2.976-4.514-5.671-4.076l0,0 c-2.695,0.438-4.526,2.974-4.089,5.663l0,0C39.817,68.062,42.356,69.887,45.051,69.449z"
              />
              <path
                fill="#0E0E11"
                d="M87.291,41.941l-21.939,2.732c-8.982,1.152-17.101-5.259-18.244-14.136 c-0.559-4.281,2.506-8.118,6.683-8.669c4.281-0.559,8.118,2.506,8.669,6.683c0.034,0.419,0.487,0.805,0.898,0.666l21.939-2.732 L87.291,41.941z"
              />
              <path
                fill="#0E0E11"
                d="M78.098,35.301l-10.86,1.41c-4.281,0.559-8.118-2.506-8.669-6.683c-0.559-4.281,2.506-8.118,6.683-8.669 l10.86-1.41c4.281-0.559,8.118,2.506,8.669,6.683C85.34,30.914,82.379,34.742,78.098,35.301z"
              />
              <polygon
                fill="#FFFFFF"
                points="50.776,108.302 64.946,150.565 69.144,164.679 72.074,150.248 77.44,123.83 80.222,108.297"
              />
              <polygon
                fill="#FFE500"
                points="70.502,114.79 72.078,150.248 69.148,164.678 64.95,150.565 63.374,115.107 66.78,111.384"
              />
              <polygon
                fill="#FFE500"
                points="74.663,118.599 66.777,111.385 59.563,119.27"
              />
            </g>
          </g>
          <ellipse
            fill="#FFFFFF"
            cx="75.699"
            cy="76.449"
            rx="1.841"
            ry="2.47"
          />
        </g>
      </g>
    </svg>
  );
}

export default EmployeeSurprise;
